import React from 'react';
import { ProfileForm } from '../components/profile/ProfileForm';
import { BusinessDetails } from '../components/profile/sections/BusinessDetails';
import { Tabs } from '../components/ui/Tabs';

export function Profile() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Profile Settings</h2>
        <p className="mt-1 text-sm text-gray-500">
          Manage your personal information and preferences
        </p>
      </div>

      <div className="space-y-8">
        {/* Personal Information */}
        <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
          <h3 className="text-lg font-medium text-gray-900">Personal Information</h3>
          <div className="mt-6">
            <ProfileForm />
          </div>
        </div>

        {/* Company Information */}
        <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
          <h3 className="text-lg font-medium text-gray-900">Company Information</h3>
          <div className="mt-6">
            <BusinessDetails />
          </div>
        </div>
      </div>
    </div>
  );
}